export default __webpack_public_path__ + "static/businessEnglishMoreCourseDetails-aa6b00fbbb49ea5a69e81210a3a9d64e.png";